<template>
  <div class="" v-if="isPropertyLoading || isUserLoading">
    <Loading />
  </div>

  <div v-else-if="userStore.isLoggedIn">
    <BethsLayout :layoutTitle="`Contacts - ${property.name}`">
      <div class="block">
        <div class="text-3xl font-bold mb-4">Staff Directory</div>

        <!-- DESKTOP DIRECTORY -->
        <div class="hidden lg:block">
          <table
            v-if="property.isStaffDirEnabled && staff?.length > 0"
            class="table-auto text-table font-normal w-full"
          >
            <tbody>
              <tr class="border-b-2 border-divider">
                <td></td>
                <td></td>
                <td>Primary</td>
                <td>Mobile</td>
              </tr>
              <tr v-for="(person, index) in staff" :class="index % 2 ? 'bg-footer' : ''">
                <td class="pl-2.5">{{ person.firstName + " " + person.lastName }}</td>
                <td>
                  <a class="text-link" :href="'mailto:' + person.contactEmail">
                    {{ person.contactEmail }}
                  </a>
                </td>
                <td>
                  <a class="text-link" :href="'tel:' + person.primaryPhone">
                    {{ person.primaryPhone }}
                  </a>
                </td>
                <td>
                  <a class="text-link" :href="'tel:' + person.mobilePhone">
                    {{ person.mobilePhone }}
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
          <p v-else class="font-normal pt-2.5">No contacts found.</p>
        </div>

        <!-- MOBILE DIRECTORY -->
        <div class="lg:hidden font-normal pt-2.5">
          <div v-if="staff?.length > 0">
            <div
              v-for="(person, index) in staff"
              :class="'p-2.5 ' + (index % 2 ? 'bg-footer' : '')"
            >
              <div>{{ person.firstName + " " + person.lastName }}</div>
              <div>{{ person.contactEmail }}</div>
              <div>{{ person.mobilePhone }}</div>
            </div>
          </div>
          <p v-else>No contacts found.</p>
        </div>
      </div>
    </BethsLayout>
  </div>

  <div v-else>You must be logged in to view this page.</div>
</template>

<script setup lang="ts">
import { useBldgStore } from "../store/bldgStore";
import { useUserStore } from "../store/userStore";
import router from "../router";

const bldgStore = useBldgStore();
const userStore = useUserStore();

var isPropertyLoading = computed(() => bldgStore.isLoading);
var property = computed(() => bldgStore.property);
var isUserLoadedFromServer = computed(() => userStore.isUserLoadedFromServer);
var user = computed(() => userStore.user);
var isUserLoading = computed(() => userStore.isUserLoading);
var staff = computed(() => property.value.staffDir);

onMounted(redirectIfNotLoggedIn);

watch(property, loadData);
async function loadData() {
  if (property?.value?.portalId) redirectIfNotLoggedIn();
}

watch(isUserLoadedFromServer, redirectIfNotLoggedIn);
watch(user, redirectIfNotLoggedIn);
function redirectIfNotLoggedIn() {
  // For portals with hideAllAnonymousContent = true:
  // If user loading attempt is complete and we're still not logged in, redirect to login page
  if (property.value && isUserLoadedFromServer.value && !userStore.isLoggedIn) {
    console.log(`Redirecting to login page (isLoggedIn = ${userStore.isLoggedIn})`);
    let currentRoute = router.currentRoute.value.path;
    router.push(`/${property.value.siteCode}/login?returnUrl=${currentRoute}`);
  }
}
</script>
